import React from 'react';
import PropTypes from 'prop-types';
import { Label, Grid } from 'semantic-ui-react';
import { translate } from 'react-i18next';

const style = {
  width: '15%',
  display: 'flex',
  justifyContent: 'space-around',
  zIndex: '100',
  position: 'absolute',
};

const ChartTooltip = ({ marginLeft, params, t }) => (
  <div style={{ ...style, marginLeft }}>
    <Label basic pointing="above">
      <Grid padded>
        {Object.keys(params).map(prop => (
          <Grid.Row key={prop}>
            <Grid.Column>
              {t(prop)}: {params[prop]}
            </Grid.Column>
          </Grid.Row>
        ))}
      </Grid>
    </Label>
  </div>
);

ChartTooltip.propTypes = {
  marginLeft: PropTypes.string.isRequired,
  params: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(ChartTooltip);



// WEBPACK FOOTER //
// ./src/components/reusable/ChartTooltip.js